import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";

// Technische tijdlijn: genummerde stappen met aandachtspunten.
export const StepTimeline = ({ steps, testid = "montage-timeline" }) => (
  <ol className="relative grid gap-5 lg:grid-cols-2" data-testid={testid}>
    {steps.map((s, i) => (
      <li key={s.title} className="card relative p-6" data-testid={`${testid}-step-${i + 1}`}>
        <div className="flex items-start gap-4">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-ink font-display text-[17px] font-bold text-white">{i + 1}</span>
          <div>
            <h3 className="text-[18px] font-semibold leading-snug text-ink">{s.title}</h3>
            <p className="mt-2 text-[14.5px] leading-relaxed text-slate-600">{s.text}</p>
            {s.checks?.length > 0 && (
              <ul className="mt-3 grid gap-1.5">
                {s.checks.map((c) => <li key={c} className="flex items-start gap-2 text-[14px] text-slate-700"><Check className="mt-0.5 h-4 w-4 shrink-0 text-maas" aria-hidden="true" />{c}</li>)}
              </ul>
            )}
            {s.link && <Link to={s.link.href} className="mt-4 inline-flex items-center gap-1.5 text-[14px] font-semibold text-maas hover:underline">{s.link.label} <ArrowRight className="h-4 w-4" aria-hidden="true" /></Link>}
          </div>
        </div>
      </li>
    ))}
  </ol>
);
